import Transformer from '../transformer'
import { auroraUserFullName } from '@/transformers/utils'

class CounterproposalTransformer extends Transformer {
  static fetch({ affected: casualty,
    id,
    file,
    request_date: requestDate,
    amount_acceptance_date: amountAcceptanceDate,
    submission_date: submissionDate,
    authorization_request_date: authorizationRequestDate,
    authorization_date: authorizationDate,
    who_authorizes: whoAuthorizes }) {
    return {
      casualty,
      id,
      file,
      requestDate,
      amountAcceptanceDate,
      submissionDate,
      authorizationRequestDate,
      authorizationDate,
      whoAuthorizesName: whoAuthorizes ? auroraUserFullName(whoAuthorizes) : null
    }
  }

  // static send({
  //   amountAcceptanceDate,
  //   submissionDate,
  //   authorizationRequestDate,
  //   authorizationDate
  // }) {
  //   return {
  //     amount_acceptance_date: amountAcceptanceDate,
  //     submission_date: submissionDate,
  //     authorization_request_date: authorizationRequestDate,
  //     authorization_date: authorizationDate
  //   }
  // }
}

export default CounterproposalTransformer
